import { cn } from "@/lib/utils";

export function PrimaryButton({
    className,
    ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
    return (
        <button
            {...props}
            className={cn(
                "bg-gold-500 text-bg-900 rounded-button",
                "font-black uppercase tracking-widest text-[11px]",
                "px-4 py-3 flex items-center justify-center gap-2",
                "shadow-[0_8px_20px_rgba(212,175,55,0.25)]",
                "transition-all duration-150",
                "hover:bg-gold-400 hover:shadow-[0_8px_25px_rgba(212,175,55,0.4)]",
                "active:scale-95",
                "disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100",
                className
            )}
        />
    );
}

export function SecondaryButton({
    className,
    ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
    return (
        <button
            {...props}
            className={cn(
                "bg-transparent text-white rounded-button",
                "border border-white/10 hover:border-gold-500/50 hover:bg-white/5",
                "font-black uppercase tracking-widest text-[11px]",
                "px-4 py-3 flex items-center justify-center gap-2",
                "transition-all duration-150",
                "active:scale-95",
                "disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100",
                className
            )}
        />
    );
}
